const errors = {
  errorUpdatingTemplate: 'Došlo je do pogreške prilikom ažuriranja predloška',
  errorUpdatingReport: 'Došlo je do pogreške prilikom ažuriranja nalaza',
  errorGeneratingReport: 'Došlo je do pogreške prilikom generiranja nalaza',
  errorDeletingReport: 'Došlo je do pogreške prilikom brisanja nalaza',
  errorCreatingTemplate: 'Došlo je do pogreške prilikom stvaranja predloška',
  errorDeletingTemplate: 'Došlo je do pogreške prilikom brisanja predloška',
  errorDuplicatingTemplate:
    'Došlo je do pogreške prilikom dupliciranja predloška',
  errorExtractingData: 'Došlo je do pogreške prilikom generiranja podataka',
  errorTogglingLanguage: 'Došlo je do pogreške prilikom promjene jezika',
  versionGuard: {
    updateRequired: 'Potrebno je ažuriranje',
    updateRequiredDescription:
      'Vaša verzija aplikacije ({{currentVersion}}) je zastarjela. Molimo, ažurirajte na verziju {{minVersion}} ili noviju za nastavak korištenja aplikacije.',
    genericMessage:
      'Molimo, ažurirajte na najnoviju verziju aplikacije Voicefill Medical za nastavak korištenja.',
    updateButton: 'Ažuriraj aplikaciju',
  },
  invalidCode: 'Neispravan kod. Pokušajte ponovno.',
  failedToSignIn: 'Pogrešna lozinka. Pokušajte ponovno.',
  failedToSendCode: 'Došlo je do pogreške prilikom slanja koda',
  failedToSignInWithGitHub: 'Prijava putem GitHuba nije uspjela',
  errorBoundary: {
    title: 'Došlo je do pogreške',
    contactSupport: 'Ako se problem ponovi, kontaktirajte podršku.',
    tryAgain: 'Pokušaj ponovno',
    backHome: 'Povratak na početnu',
  },
};

export default errors;
